import React from "react";
import {
  Paper,
  Grid,
  TextField,
  IconButton,
  Alert,
  Box,
  Chip,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import LockIcon from "@mui/icons-material/Lock";

const formatNumber = (value) => {
  if (!value && value !== 0) return "";

  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue)) return "";

  const [entero, decimal] = numValue.toFixed(2).split(".");
  const enteroFormateado = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  return `${enteroFormateado},${decimal}`;
};

const RenderRenglonLink = ({
  renglon,
  index,
  handleCantidadChange,
  handleProductoChange,
  handlePrecioChange,
  eliminarLinea,
}) => {
  const cantidad = parseFloat(renglon.cantidad) || 0;
  const precioConIva = parseFloat(renglon.precio) || 0;
  const porcentajeIva = parseFloat(renglon.iva) || 0;

  const totalRenglon = cantidad * precioConIva;
  const subtotalRenglon = totalRenglon / (1 + porcentajeIva / 100);
  const ivaRenglon = totalRenglon - subtotalRenglon;

  // Determinar el valor a mostrar en el campo de precio
  const precioMostrar =
    renglon.tiene_precio_especial === 1 && renglon.precio_fijo !== null
      ? String(renglon.precio_fijo || "")
      : renglon.precio !== null && renglon.precio !== undefined
        ? String(renglon.precio)
        : "";

  return (
    <Paper sx={{ mb: 0.5, p: 2, border: "1px solid #e0e0e0" }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={1}>
          <TextField
            fullWidth
            size="small"
            label="Cant."
            InputProps={{ readOnly: true }}
            value={renglon.cantidad.toString()}
            type="number"
            onChange={(e) => handleCantidadChange(index, e.target.value)}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            size="small"
            label="Producto"
            value={renglon.abreviatura}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            size="small"
            label="Precio Unit."
            value={precioMostrar}
            // type=""
            onKeyPress={(event) => {
              if (!/[0-9.]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onChange={(e) => handlePrecioChange(index, e.target.value)}
            error={
              renglon.precioEstado === "min" || renglon.precioEstado === "max"
            }
            disabled={renglon.tiene_precio_especial === 1}
            InputProps={{
              readOnly: renglon.tiene_precio_especial === 1,
              endAdornment:
                renglon.tiene_precio_especial === 1 ? (
                  <Chip
                    size="small"
                    label="Fijo"
                    color="primary"
                    sx={{ ml: 1 }}
                  />
                ) : null,
            }}
            helperText={
              renglon.tiene_precio_especial === 1
                ? "Precio fijo (no editable)"
                : renglon.precioEstado === "min"
                  ? `Mínimo: $${renglon.precio_minimo}`
                  : renglon.precioEstado === "max"
                    ? `Máximo: $${renglon.precio_maximo}`
                    : ""
            }
          />
        </Grid>
        <Grid item xs={1}>
          {renglon.tiene_precio_especial === 1 && (
            <Tooltip title="Precio fijo (no editable)">
              <LockIcon color="primary" />
            </Tooltip>
          )}
        </Grid>
        {/* <Grid item xs={2}>
          {index === 0 ? null : (
            <Tooltip title={"Eliminar Renglon"}>
            <IconButton color="error" onClick={() => eliminarLinea(index)}>
              <DeleteIcon />
            </IconButton>
            </Tooltip>
          )}
        </Grid> */}
      </Grid>

      {renglon.precioEstado === "min" && (
        <Alert severity="warning" sx={{ mt: 0.25 }}>
          El precio es menor al Precio Mínimo ($
          {formatNumber(renglon.precio_minimo)})
        </Alert>
      )}

      {renglon.precioEstado === "max" && (
        <Alert severity="error" sx={{ mt: 0.25 }}>
          El precio es mayor al Precio Máximo ($
          {formatNumber(renglon.precio_maximo)})
        </Alert>
      )}

      <Box sx={{ mt: 0.5, display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Chip
          size="small"
          label={`Subtotal: $${formatNumber(subtotalRenglon)}`}
          variant="outlined"
        />
        <Chip
          size="small"
          label={`IVA (${porcentajeIva}%): $${formatNumber(ivaRenglon)}`}
          variant="outlined"
        />
        <Chip
          size="small"
          label={`Total: $${formatNumber(totalRenglon)}`}
          color="primary"
        />
      </Box>
    </Paper>
  );
};

export default RenderRenglonLink;
